<template>
	<div class="main">
		<div class="row">
			<div class="col-md-4">
				<router-link to="/services" class="btn btn-info">{{ $t('Back') }}</router-link>
			</div>
			<div class="col-md-4 text-center">
				<h3 class="screen-detail-title">{{ service.description }}</h3>
			</div>
			<div class="col-md-4 text-right">
				<router-link v-bind:to="'/services/' + service.idService + '/edit'" class="btn btn-default">{{ $t('Edit') }}</router-link>
				<router-link v-bind:to="'/services/' + service.idService + '/requests'" class="btn btn-info">{{ $t('Requests') }}</router-link>
			</div>
		</div>
		<hr />
		<div class="row">
			<div class="col-md-4">
				<div class="panel panel-default panel-body text-center">
					<h5>{{ $t('Requests') }}</h5>
					<h5>{{ statistics.requestsCount }}</h5>
				</div>
			</div>
			<div class="col-md-4">
				<div class="panel panel-default panel-body text-center">
					<h5>{{ $t('Average Duration') }}</h5>
					<h5>{{ statistics.averageDuration }} ms</h5>
				</div>
			</div>
			<div class="col-md-4">
				<div class="panel panel-default panel-body text-center">
					<h5>{{ $t('Fails') }}</h5>
					<h5>{{ statistics.failsCount }}</h5>
				</div>
			</div>
		</div>
		<h5>{{ $t('Requests in the last 15 days') }}</h5>
		<div v-if="statistics.requestsChart" class="panel panel-default panel-body">
			<highcharts :options="statistics.requestsChart"></highcharts>
		</div>
	</div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import moment from "moment";

export default {
	props: {
		servicesService: {
			type: Object,
		}
	},
	components:  {
		highcharts: Chart
	},
	data() {
		return {
			service: {},
			statistics: {},
			chartOptions: {
				series: [{
					data: [1,2,3]
				}]
			}
		};
	},
	methods: {
		formatDate(value) {
			return moment(value).format("DD/MM/YYYY HH:mm:ss");
		},
		formatJSON(value) {
			return JSON.stringify(JSON.parse(value), undefined, "   ");
		},
	},
	async created() {
		const idService = this.$route.params.idService;
		this.service = await this.servicesService.getService(idService);
		this.statistics = await this.servicesService.getServiceStatistics(idService);
	},
};
</script>

<style>
.main {
	padding: 30px;
}
.text-right {
	text-align: right;
}
pre {
	background-color: transparent !important;
	border: 0 !important;
	white-space: pre-wrap;
	word-wrap: break-word;
}
.request {
	height: 100px !important;
}
</style>
